import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const SET_FILTERS_USER_LIST = "SET_FILTERS_USER_LIST";

export interface SetFiltersUserListAction extends Action {
  type: typeof SET_FILTERS_USER_LIST;
  values: { [key: string]: any };
  organization: OrganizationKeyName;
  refreshList: boolean;
}

export const setFiltersUserListAction = (
  organization: OrganizationKeyName,
  values: { [key: string]: any },
  refreshList = true
): SetFiltersUserListAction => ({
  type: SET_FILTERS_USER_LIST,
  values,
  organization,
  refreshList,
});
